import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import type { GetTeamsQuerySchema } from "@msuite/utils/schemas";
import { client } from "@/hono";
import { useCitadel } from "@/hooks/use-citadel";

export function useTeams(query?: GetTeamsQuerySchema) {
	/** Context */
	const { citadel } = useCitadel();

	/** Hooks */
	const _query = useQuery({
		queryFn: async () => {
			const response = await client.organizations.teams.$get({ query: query ?? {} });
			const data = await responseHandler(response);
			return data.teamsList;
		},
		queryKey: ["organization", "teams", JSON.stringify(query)],
		// The server gates the team list on `read Team`, which a member does not hold. The hook
		// is used from screens a member does reach — the people list among them — so the request
		// is not sent rather than answered with a refusal and a toast.
		enabled: citadel?.can("read", "Team") === true,
	});

	return { ..._query, teams: guardArray(_query.data) };
}
